export default __webpack_public_path__ + "static/media/app-confirmed.650ee9f3.png";